"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import FacultyCardWithDescription from "@molecules/FacultyCardWithDescription/FacultyCardWithDescription";
import { Autoplay, Pagination } from "swiper/modules";
import ClickToScroll from "@/components/sections/NewLists/ClickToScroll";

export default function FacultyWithDescription({ isDesktop, faculties }) {
  if (isDesktop) {
    return (
      <div className={styles.root} id="landingPageFacultyList">
        <ClickToScroll id="landingPageFacultyList" />
        {faculties.map((d, index) => (
          <FacultyCardWithDescription key={index} {...d?.attributes} />
        ))}
      </div>
    );
  }

  return (
    <div className="Carousel px-3">
      <Swiper
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={1.1}
        pagination={{ clickable: true }}
        className="Carousel__blueBullet Carousel__hAuto"
      >
        {faculties.map((d, index) => (
          <SwiperSlide key={index}>
            <FacultyCardWithDescription {...d?.attributes} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
